import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NaReuseTabComponent } from './na-reuse-tab.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule
  ],
  exports: [
    NaReuseTabComponent
  ],
  declarations: [NaReuseTabComponent]
})
export class NaReuseTabModule { }
